import React, { useState, useEffect } from 'react';
import * as DOMPurify from 'dompurify';

import Header1 from '../Layout/Header1';
import Footer from '../Layout/Footer';
import getBaseUrl from '../../base/htttp';
import init from '../../js/main';
function Index() {    
	const [data, setData] = useState("Loading...");

	useEffect(() => {
		const getData = async ()  => {
			await fetch(getBaseUrl()+"page")        
				.then(async (response) => await response.json())
				.then(async (result) => {
					setData(result.data);
							
			});	
			 setTimeout(function() {
				init();
			 }.bind(this), 4);						
		}

		getData();		
	}, []);
	
	const sanitizedContent = DOMPurify.sanitize(data.content, {
        ADD_TAGS: ['iframe','embed'],
        ADD_ATTR: ['src','target'],        
      });

	return (        
		<div>			
            <Header1 />			
			<div className="main" dangerouslySetInnerHTML={{__html: sanitizedContent}}></div>
			<Footer />
		</div>
	);
}

export default Index;